export const tabletViewport = 990;
